var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"series"},[_c('h1',[_vm._v("车系页面")]),_c('p',[_vm._v("这是车系展示页面，实际开发中会显示所有汽车车系")])])
}]

export { render, staticRenderFns }